<template>
	<v-row justify="center" id="auth_bottom" class="text-center">
		<v-col cols="11" md="11" lg="5">
			<InicioSesionClaveTributaria
				:config="claveTributariaConfig"
			/>
		</v-col>
		<v-col v-if="!ocultarCU" sm="11" lg="1" cols="11" class="vertical pa-0">
			<b class="interjeccion subtitle-1 mb-0 pb-0">o</b>
		</v-col>
		<v-col cols="11" sm="11" lg="5" v-if="!ocultarCU">
			<InicioSesionClaveUnica
				:config="claveUnicaConfig"
			/>
		</v-col>
	</v-row>
</template>
<script>

import InicioSesionClaveTributaria from './InicioSesionClaveTributaria.vue'
import InicioSesionClaveUnica from './InicioSesionClaveUnica.vue'

import { identityProviders } from '@/config';

export default {
	components:{
		InicioSesionClaveTributaria, InicioSesionClaveUnica
	},
	data() {
		return {
			identityProviders: identityProviders,
			claveUnicaConfig: identityProviders.claveUnica,
			claveTributariaConfig: identityProviders.claveTributaria,
			ocultarCU:true,
		}
	},
	mounted(){

		this.claveUnicaConfig = this.identityProviders.claveUnica;
		this.claveTributariaConfig = this.identityProviders.claveTributaria;
	}
}
</script>
<style>
	.interjeccion {
		display: block;
		text-align: center;
		margin-bottom: 12px;
		font-size: 18px;
		line-height: 22px;
	}

	.vertical {
		display: grid;
    align-items: center;
	}

</style>